import {
  Body,
  getImgProps,
  Heading,
  Img,
  Label,
  Link,
  TextVerticalSpacer,
  VerticalSpacer,
} from '@superhi/design'
import React from 'react'

import { buildPath } from '../../../../../../routing/utils'

import { Inner } from './styles'

type Props = {
  number: number
  title: string
  description: string
  imageUrl: string
  slug: string
}

const VS_1 = { small: 12, medium: 16, large: 24 }
const Chapter: React.FC<Props> = ({ number, title, description, imageUrl, slug }) => {
  const imageProps = React.useMemo(
    () =>
      getImgProps(
        imageUrl,
        {
          small: 100,
          medium: 50,
          large: 25,
          xlarge: 25,
        },
        {
          fm: 'png8',
        },
      ),
    [imageUrl],
  )

  const href = React.useMemo(() => buildPath('posts-view', { params: { postSlug: slug } }), [slug])

  return (
    <Link href={href} color="GREY_90" hoverColor="BLUE_50" block>
      <Inner>
        <div>
          <Img {...imageProps} aspectRatio="16:9" alt="" lazy isRounded />
        </div>

        <VerticalSpacer amount={VS_1}>
          <TextVerticalSpacer level="4">
            <Label color="GREY_70">Chapter {number}</Label>

            <Heading level="4">{title}</Heading>

            <Body color="GREY_90" level="3">
              {description}
            </Body>
          </TextVerticalSpacer>
        </VerticalSpacer>
      </Inner>
    </Link>
  )
}

export default Chapter
